const setStorageItem = (storage: Storage) => (key: string, value: unknown) => {
  if (typeof storage === 'undefined') return
  storage.setItem(
    key,
    JSON.stringify({
      value,
      createdAt: Date.now(),
    }),
  )
}

const getStorageItem = (storage: Storage) => (key: string) => {
  if (typeof storage === 'undefined') return
  try {
    const data = storage.getItem(key)
    if (!data) return null
    return JSON.parse(data)
  } catch (error) {
    return null
  }
}

const removeStorageItem = (storage: Storage) => (key: string) => {
  storage.removeItem(key)
}

const voidFn = () => {}
const isLocalStorageAvailable = () => typeof localStorage !== 'undefined'
const isSessionStorageAvailable = () => typeof sessionStorage !== 'undefined'

export const storage = {
  localStorage: {
    setItem: isLocalStorageAvailable() ? setStorageItem(localStorage) : voidFn,
    getItem: isLocalStorageAvailable() ? getStorageItem(localStorage) : voidFn,
    removeItem: isLocalStorageAvailable() ? removeStorageItem(localStorage) : voidFn,
  },
  sessionStorage: {
    setItem: isSessionStorageAvailable() ? setStorageItem(sessionStorage) : voidFn,
    getItem: isSessionStorageAvailable() ? getStorageItem(sessionStorage) : voidFn,
    removeItem: isSessionStorageAvailable() ? removeStorageItem(sessionStorage) : voidFn,
  },
}
